__turbopack_context__.v({
  "content": "scroll-area-module-scss-module__MK08Oq__content",
  "corner": "scroll-area-module-scss-module__MK08Oq__corner",
  "fillViewport": "scroll-area-module-scss-module__MK08Oq__fillViewport",
  "fillViewportContent": "scroll-area-module-scss-module__MK08Oq__fillViewportContent",
  "root": "scroll-area-module-scss-module__MK08Oq__root",
  "safeAreaBottomContent": "scroll-area-module-scss-module__MK08Oq__safeAreaBottomContent",
  "scrollbar": "scroll-area-module-scss-module__MK08Oq__scrollbar",
  "thumb": "scroll-area-module-scss-module__MK08Oq__thumb",
  "viewport": "scroll-area-module-scss-module__MK08Oq__viewport",
});
